import { useFlagStore } from '@/stores/flag';
import pinia from '@/stores/pinia';

export function isDmGroupingEnabled() {
  try {
    const flagStore = useFlagStore(pinia);
    return flagStore.ready && flagStore.flags.communityDmGrouping;
  } catch {
    return false;
  }
}
